package com.evoapps.evoshift.domain.usecase.owner

import com.evoapps.evoshift.domain.model.ContractType
import com.evoapps.evoshift.domain.repository.OwnerRepository

class GetContractTypesUseCase(private val repository: OwnerRepository) {
    suspend operator fun invoke(ownerId: String): Result<List<ContractType>> {
        return repository.getContractTypes(ownerId)
    }
}

class AddContractTypeUseCase(private val repository: OwnerRepository) {
    suspend operator fun invoke(ownerId: String, contractType: ContractType): Result<String> {
        return repository.addContractType(ownerId, contractType)
    }
}

class UpdateContractTypeUseCase(private val repository: OwnerRepository) {
    suspend operator fun invoke(ownerId: String, contractType: ContractType): Result<Unit> {
        return repository.updateContractType(ownerId, contractType)
    }
}

class DeleteContractTypeUseCase(private val repository: OwnerRepository) {
    suspend operator fun invoke(ownerId: String, contractTypeId: String): Result<Unit> {
        return repository.deleteContractType(ownerId, contractTypeId)
    }
}
